
<div class="absolute inset-y-0 left-0 md:static md:flex-shrink-0 shadow-md">
  <div class="flex items-center px-10 h-16 w-16 bg-primary focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600 md:w-0 animate-width {{menuMode === 'expanded' ? 'nav-expanded' : 'nav-collapsed'}}"
       [class.justify-center]="menuMode === 'collapsed'"
       [class.justify-between]="menuMode === 'expanded'">
    <img *ngIf="menuMode === 'expanded'" class="h-8 w-auto hidden md:block" src="assets/logos/logotipo_blanco.png" alt="Workflow">
    <button (click)="changeMenuMode()"><svg class="h-8 w-auto text-white  hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg></button>
  </div>
</div>
